{
  "nl": {
    "profile": {
      "subNav": {
        "general": "Mijn Profiel",
        "account": "Account bewerken",
        "privacy": "Privacy",
        "licenses": "Mijn Licenties",
        "emailSettings": "E-mailinstellingen",
        "authorizedApplications": "Partner Logins",
        "export": "Gegevensexport"
      },
      "general": {
        "title": "Profiel",
        "sectionName": "Naam",
        "sectionLocality": "Beroep & School",
        "sectionCommunity": "Community",
        "sectionSettings": "Instellingen",
        "nameHint": "We hebben deze gegevens nodig voor de deelnamecertificaten.",
        "nameHintInternational": "Je volledige naam wordt alleen gebruikt als je deelneemt aan een van onze trainingen, zodat we je een officieel deelnamecertificaat kunnen uitreiken.",
        "localityHint": "Verbeter je persoonlijke aanbevelingen door meer informatie toe te voegen (optioneel).",
        "localityHintInternational": "Met de volgende gegevens help je ons om je de best mogelijke ervaring te bieden:",
        "communityHint": "Deze gegevens zijn optioneel en worden gebruikt in onze galerij voor lesmateriaal.",
        "firstname": "Voornaam",
        "lastname": "Achternaam",
        "job": "Beroep",
        "customJob": "Ander beroep",
        "schoolType": "Schooltype",
        "schoolTypeCustom": "Ander schooltype",
        "subjectList": "Vakken",
        "customSubject": "Ander vak",
        "avatar": "Profielfoto",
        "avatarHelp": "200x200 pixels aanbevolen",
        "avatarUploadError": "De profielfoto kon niet worden geüpload.",
        "avatarUploadProgress": "Profielfoto wordt geüpload",
        "communityName": "Community-naam",
        "communityNameHelp": "Als je een andere naam wilt gebruiken voor het delen van materiaal, kun je die hier invoeren. Anders gebruiken we je voor- en achternaam.",
        "timezone": "Tijdzone",
        "timeFormat": "Tijdnotatie",
        "locale": "Taal van de gebruikersinterface",
        "contentLanguage": "Inhoudstaal",
        "contentLanguageOptions": {
          "false": "Duitstalige aanbiedingen 🇩🇪 🇦🇹 🇨🇭",
          "true": "Engelstalige aanbiedingen 🌎"
        },
        "timeFormatOptions": {
          "TWELVE_HOURS": "12 uur",
          "TWENTY_FOUR_HOURS": "24 uur"
        },
        "jobOptions": {
          "JOB_TEACHER": "Docent",
          "JOB_LEADING_TEACHER": "Vakcoördinator",
          "JOB_PRINCIPAL": "Schoolleiding",
          "JOB_UNIVERSITY_STUDENT": "Student",
          "JOB_TEACHER_TRAINEE": "Leraar in opleiding",
          "JOB_PARENT": "Ouder",
          "JOB_SOCIAL_WORKER": "Sociaal pedagoog",
          "JOB_FACULTY_MEMBER": "Hogeschooldocent",
          "JOB_ADMINISTRATIVE_STAFF": "Administratief medewerker",
          "JOB_OTHER": "Overig"
        },
        "selectPlaceholder": "Selecteer",
        "privacyDeletionNotice": "Privacyverklaring: Als je account langer dan twee jaar inactief is, informeren we je per e-mail over de geplande automatische verwijdering. Als je het niet binnen een maand na de melding heractiveert, wordt het automatisch verwijderd.",
        "save": "Opslaan",
        "cancel": "Annuleren",
        "deleteAccount": "Account verwijderen",
        "deleteAccountDescription": "Het verwijderen van je account is onomkeerbaar. Al je gegevens worden verwijderd.",
        "deleteAccountConfirmation": "Weet je zeker dat je je account wilt verwijderen?",
        "deleteAccountButton": "Account definitief verwijderen",
        "successMessage": "Profiel succesvol bijgewerkt.",
        "errorMessage": "Het profiel kon niet worden bijgewerkt."
      },
      "account": {
        "title": "Account bewerken",
        "email": "E-mail",
        "password": "Nieuw wachtwoord",
        "passwordHelp": "Leeg laten als je het niet wilt wijzigen.",
        "currentPassword": "Huidig wachtwoord",
        "currentPasswordHelp": "We hebben je huidige wachtwoord nodig om wijzigingen te bevestigen.",
        "save": "Opslaan",
        "cancel": "Annuleren",
        "invoiceEmailNotice": "Ga naar <a href=\"{portalUrl}\">Abonnementenbeheer</a> om je factuur-e-mail te wijzigen.",
        "unconfirmedEmail": "We hebben een bevestigingsmail gestuurd naar je nieuwe adres. Bevestig deze alstublieft.",
        "oauthConnected": "Verbonden met",
        "oauthConnect": "Verbind je fobizz account",
        "connectButton": "Verbinden met {provider}",
        "disconnect": "Verbinding verbreken",
        "fobizzId": "fobizz ID",
        "successMessage": "Account succesvol bijgewerkt.",
        "errorMessage": "Het account kon niet worden bijgewerkt."
      },
      "disconnectOauth": {
        "title": "Verbinding met {provider} verbreken",
        "hint": "Kies een wachtwoord zodat je na het verbreken van de verbinding kunt inloggen.",
        "password": "Nieuw wachtwoord",
        "submit": "Verbinding verbreken",
        "cancel": "Annuleren",
        "successMessage": "De verbinding is succesvol verbroken.",
        "errorMessage": "De verbinding kon niet worden verbroken."
      },
      "privacy": {
        "title": "Privacy-instellingen",
        "embedConsent": {
          "paragraph": "Je gaat ermee akkoord dat video-inhoud in trainingen wordt geladen en dat de benodigde gegevens, met name je IP-adres, aan de aanbieder worden doorgegeven. Met deze toestemming is het mogelijk om de video's in de trainingen te bekijken. Meer informatie vind je in onze privacyverklaring.",
          "agree": "Toestemming geven",
          "disagree": "Toestemming intrekken"
        }
      },
      "licenses": {
        "title": "Mijn Licenties",
        "sectionSubscriptions": "Abonnementen en individuele licenties",
        "subtitleSubscriptions": "Je hebt de volgende individuele licenties geboekt:",
        "sectionMemberships": "Lidmaatschappen in licentie groepen",
        "subtitleMembershipsWithGroups": "De volgende licentie groepen geven je recht om de verschillende aanbiedingen te gebruiken:",
        "manageSubscription": "Abonnement beheren",
        "portalError": "Het abonnementsportaal kon niet worden geopend.",
        "buyNow": "Nu kopen",
        "activatedAt": "Geactiveerd op",
        "nextBilling": "Volgende betaling",
        "billingPeriod": "Betalingsperiode",
        "billingPeriodUnits": {
          "year": "Jaarlijks",
          "month": "Maandelijks"
        },
        "paused": "Gepauzeerd",
        "resumed": "Voortgezet",
        "cancelledAt": "Beëindigd op",
        "usageUntil": "Geldig tot",
        "price": "Prijs",
        "statusExpired": "Verlopen",
        "statuses": {
          "ACTIVE": "Actief",
          "IN_TRIAL": "Proefperiode",
          "NON_RENEWING": "Loopt af",
          "PAUSED": "Gepauzeerd",
          "CANCELLED": "Opgezegd",
          "FUTURE": "Toekomstig"
        },
        "planTitles": {
          "combined": "Nascholingsflatrate + Toolsflatrate",
          "courses": "Nascholingsflatrate",
          "tools": "Toolsflatrate"
        },
        "planDescriptions": {
          "combined": "Onbeperkte toegang tot alle fobizz nascholingsaanbiedingen, fobizz tools en AI-assistentie voor de les.",
          "courses": "Onbeperkte toegang tot alle fobizz nascholingsaanbiedingen.",
          "tools": "Onbeperkte toegang tot fobizz tools en AI-assistentie voor de les."
        },
        "offerHeading": "Jouw flexibele fobizz abonnement",
        "offerDescription": "Heb je zin om je altijd flexibel bij te scholen of de fobizz tools en AI onbeperkt te gebruiken? Maak kennis met alle fobizz aanbiedingen.",
        "offerButton": "Aanbiedingen vergelijken",
        "offerHint": "Let op: Vanwege btw-bepalingen kunnen we momenteel geen licenties aanbieden aan <strong>individuele gebruikers</strong> buiten de Europese Unie en Zwitserland. We bieden echter wel licenties aan voor scholen en onderwijsinstellingen <strong>in alle landen</strong>."
      },
      "emailSettings": {
        "title": "E-mailinstellingen",
        "subheading": "E-mailmeldingen",
        "labelCourses": "Meldingen over nieuwe cursussen, live webinars, kortingsacties en schoolacties (aanbevolen)",
        "frequency": "Nieuwsbrief frequentie",
        "frequencyOptions": {
          "WEEKLY": "Wekelijks",
          "NEVER": "Nooit"
        },
        "save": "Opslaan",
        "successMessage": "E-mailinstellingen bijgewerkt.",
        "errorMessage": "De e-mailinstellingen konden niet worden bijgewerkt."
      },
      "authorizedApplications": {
        "title": "Partnerlogins",
        "hint": "Deze partnerapplicaties zijn verbonden met je fobizz account. Ga naar de <a href=\"https://app.fobizz.com/en/partners\" class=\"text-decoration-underline\">partners</a>.",
        "application": "Applicatie",
        "createdAt": "Verbonden sinds",
        "revoke": "Intrekken",
        "revokeConfirmation": "Weet je het zeker?",
        "noApplications": "Geen geautoriseerde applicaties."
      },
      "export": {
        "title": "Data-export",
        "description": "Hier kun je al je gegevens downloaden. De export wordt aangeboden als ZIP-bestand en bevat al je gegevens in JSON-formaat en alle geüploade bestanden.",
        "buttonCreate": "Gegevens exporteren",
        "buttonDownload": "Data-export downloaden",
        "confirmCreate": "Wil je een data-export starten?",
        "processing": "Er wordt een data-export verwerkt. Het kan enkele uren duren om deze te genereren. Je ontvangt een e-mail zodra deze klaar is.",
        "availableUntil": "De export is 3 dagen beschikbaar en wordt daarna verwijderd."
      }
    }
  }
}
